export interface LoginPropsType {}

export enum LoginStep {
  PHONE,
  OTP,
  NAME,
  EMAIL,
  HANDLE,
  NAME_EMAIL,
}
